import React from 'react';

import { Theme } from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import classnames from 'classnames';

import { useFiltersContext } from './context/FixedFiltersContext';

const styles = ({ spacing: { unit } }: Theme) =>
  createStyles({
    contentWrapper: {
      padding: `${unit * 2}px ${unit * 3}px`,
      minHeight: 50,
      maxHeight: 150,
      overflow: 'auto',
    },
    readOnly: {
      '& div': {
        pointerEvents: 'none',
      },
    },
  });

interface FiltersListWrapperProps extends WithStyles<typeof styles> {}

const FiltersListWrapper: React.FC<FiltersListWrapperProps> = ({ children, classes }) => {
  const { readOnly } = useFiltersContext();

  return (
    <div
      className={classnames(classes.contentWrapper, {
        [classes.readOnly]: readOnly,
      })}
    >
      {children}
    </div>
  );
};

export default withStyles(styles)(FiltersListWrapper);
